module.exports = __webpack_public_path__ + "img/201603-1-1024x1024.e34ace17.png";